<template>
  <Transition v-bind="$attrs">
    <div v-show="showContent">
      <slot />
    </div>
  </Transition>
</template>

<script setup lang="ts">
// BaseTransition as component name doesn't work because it's already a native vue component
interface BaseTransitionsProps {
  showContent: boolean
}

const { showContent } = defineProps<BaseTransitionsProps>()
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease-in-out;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
